import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "a",
      width: "24",
      height: "24",
      x: "0",
      y: "0",
      maskUnits: "userSpaceOnUse",
      style: {"mask-type":"alpha"}
    }, [
      _createElementVNode("path", {
        fill: "#D9D9D9",
        d: "M0 0h24v24H0z"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#114A4E",
        d: "M11 18q2.9 0 4.95-2.042T18 11q0-2.9-2.05-4.95T11 4Q8.085 4 6.042 6.05 4 8.1 4 11q0 2.915 2.042 4.958Q8.084 18 11 18m0-3.154a6.05 6.05 0 0 1-3.256-.929 6.66 6.66 0 0 1-2.35-2.48.88.88 0 0 1 0-.873A6.64 6.64 0 0 1 7.75 8.083q1.5-.93 3.251-.93a5.96 5.96 0 0 1 3.238.937 6.8 6.8 0 0 1 2.343 2.473.88.88 0 0 1 0 .874 6.7 6.7 0 0 1-2.343 2.48q-1.485.93-3.238.93m0-1.192q1.423 0 2.621-.706A5.07 5.07 0 0 0 15.508 11a5.15 5.15 0 0 0-1.887-1.94A5.03 5.03 0 0 0 11 8.346q-1.439 0-2.641.714A5.14 5.14 0 0 0 6.467 11a5.06 5.06 0 0 0 1.892 1.948q1.203.706 2.641.706m0-1.154q.624 0 1.063-.43A1.44 1.44 0 0 0 12.5 11q0-.624-.437-1.063A1.45 1.45 0 0 0 11 9.5a1.44 1.44 0 0 0-1.07.437A1.46 1.46 0 0 0 9.5 11q0 .64.43 1.07t1.07.43m0 7a8.3 8.3 0 0 1-3.315-.67 8.6 8.6 0 0 1-2.697-1.818 8.6 8.6 0 0 1-1.819-2.697A8.3 8.3 0 0 1 2.5 11q0-1.755.67-3.3a8.542 8.542 0 0 1 4.515-4.53A8.3 8.3 0 0 1 11 2.5q1.755 0 3.3.67a8.6 8.6 0 0 1 2.704 1.826A8.6 8.6 0 0 1 18.83 7.7q.669 1.545.669 3.3a8.2 8.2 0 0 1-.53 2.948 8.9 8.9 0 0 1-1.464 2.514l3.477 3.477a.67.67 0 0 1 .21.517.758.758 0 0 1-1.28.517l-3.467-3.452a8.7 8.7 0 0 1-2.513 1.457A8.3 8.3 0 0 1 11 19.5"
      })
    ], -1)
  ])))
}
export default { render: render }